import { render, staticRenderFns } from "./AttendInfo.vue?vue&type=template&id=96f17940&scoped=true&"
import script from "./AttendInfo.vue?vue&type=script&lang=ts&"
export * from "./AttendInfo.vue?vue&type=script&lang=ts&"
import style0 from "./AttendInfo.vue?vue&type=style&index=0&id=96f17940&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f17940",
  null
  
)

export default component.exports